/** A full page reload, behind a seam: jsdom's `location.reload` can't be stubbed. */
export function reloadPage(): void {
  window.location.reload();
}
